// Field schemas for the schema-driven CollectionManager.
export const SCHEMAS = {
  services: {
    title: "Treatments",
    subtitle: "Add, edit and reorder treatment pages. Each has its own SEO-friendly page.",
    labelKey: "name",
    idKey: "slug",
    fields: [
      { key: "name", label: "Name", type: "text" },
      { key: "slug", label: "URL Slug", type: "text", help: "e.g. dry-needling (used in the page address)" },
      { key: "category", label: "Category", type: "text" },
      { key: "tagline", label: "Short Tagline", type: "text" },
      { key: "image", label: "Image", type: "image", recommended: "1600×1200 (4:3)" },
      { key: "what_is_it", label: "What is it?", type: "textarea" },
      { key: "why_recommended", label: "Why might it be recommended?", type: "textarea" },
      { key: "what_it_feels_like", label: "What does treatment feel like?", type: "textarea" },
      { key: "role_in_approach", label: "Role in the Psalm 30:2 approach", type: "textarea" },
      { key: "who_is_it_for", label: "Who might it be for?", type: "textarea" },
      { key: "what_to_expect", label: "What to expect", type: "textarea" },
      { key: "limitations", label: "Limitations & considerations", type: "textarea" },
      { key: "integration", label: "Integration with other care", type: "textarea" },
      { key: "published", label: "Published (visible on site)", type: "bool" },
    ],
  },
  conditions: {
    title: "Conditions",
    subtitle: "The 'What Hurts?' concern pages that connect symptoms to relevant care.",
    labelKey: "name",
    idKey: "slug",
    fields: [
      { key: "name", label: "Name", type: "text" },
      { key: "slug", label: "URL Slug", type: "text" },
      { key: "image", label: "Image", type: "image", recommended: "1600×1200 (4:3)" },
      { key: "summary", label: "Short Summary", type: "textarea", rows: 2 },
      { key: "detail", label: "Detail", type: "textarea", rows: 5 },
      { key: "related_services", label: "Related Treatment Slugs", type: "list", help: "One treatment slug per line, e.g. chiropractic-care" },
      { key: "published", label: "Published", type: "bool" },
    ],
  },
  testimonials: {
    title: "Patient Stories",
    subtitle: "Editorial testimonials. Hide any story with the Published toggle.",
    labelKey: "name",
    fields: [
      { key: "name", label: "Patient Name", type: "text" },
      { key: "location", label: "Location", type: "text" },
      { key: "image", label: "Photo", type: "image", recommended: "1200×1500 (4:5)" },
      { key: "quote", label: "Headline Quote", type: "textarea", rows: 2 },
      { key: "before", label: "Before care", type: "textarea", rows: 2 },
      { key: "wanted", label: "Wanted back", type: "textarea", rows: 2 },
      { key: "changed", label: "What changed", type: "textarea", rows: 2 },
      { key: "now", label: "Now", type: "textarea", rows: 2 },
      { key: "published", label: "Published", type: "bool" },
    ],
  },
  staff: {
    title: "Staff",
    subtitle: "Doctors and team members shown on the About page.",
    labelKey: "name",
    fields: [
      { key: "name", label: "Name", type: "text" },
      { key: "role", label: "Role / Title", type: "text" },
      { key: "image", label: "Photo", type: "image", recommended: "1200×1500 (4:5)" },
      { key: "bio", label: "Biography", type: "textarea", rows: 6 },
      { key: "published", label: "Published", type: "bool" },
    ],
  },
  memberships: {
    title: "Memberships",
    subtitle: "Configurable membership offerings. Payments are not yet enabled online.",
    labelKey: "name",
    fields: [
      { key: "name", label: "Name", type: "text" },
      { key: "who", label: "Who is included", type: "text" },
      { key: "price", label: "Price", type: "text", help: "e.g. $99 or leave as $—" },
      { key: "cadence", label: "Cadence", type: "text", help: "e.g. per month" },
      { key: "includes", label: "Included Benefits", type: "list" },
      { key: "note", label: "Fine Print", type: "textarea", rows: 2 },
      { key: "featured", label: "Featured (highlighted)", type: "bool" },
      { key: "published", label: "Published", type: "bool" },
    ],
  },
  articles: {
    title: "Education Articles",
    subtitle: "Your content hub. Publish articles, clinical education and updates.",
    labelKey: "title",
    idKey: "slug",
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "slug", label: "URL Slug", type: "text" },
      { key: "category", label: "Category", type: "text" },
      { key: "author", label: "Author", type: "text" },
      { key: "excerpt", label: "Excerpt", type: "textarea", rows: 2 },
      { key: "cover_image", label: "Cover Image", type: "image", recommended: "1600×1067 (3:2)" },
      { key: "body", label: "Body", type: "textarea", rows: 12, help: "Separate paragraphs with a blank line." },
      { key: "published", label: "Published", type: "bool" },
    ],
  },
  faqs: {
    title: "FAQs",
    subtitle: "Questions shown on the Contact page.",
    labelKey: "q",
    fields: [
      { key: "q", label: "Question", type: "text" },
      { key: "a", label: "Answer", type: "textarea", rows: 3 },
      { key: "published", label: "Published", type: "bool" },
    ],
  },
};
